/* The body of a lesson: an introduction, the goal, the ten materials.

   The crumbs, the billboard and what else there is in the subject belong to
   every material and stay on MaterialPage; this is the half that a lesson has
   and an old worked example does not.

   The order is the argument. The goal comes first because it is the one thing
   a teacher decides from, and the materials come after it because they are how
   it is reached. `blocks` sits above both — it is the situation this lesson was
   written for, and a lesson with nothing to say there simply has none.

   OWNED BY ITEM 3 OF PLAN.md. */

import { Blocks } from "../../blocks";
import type { LessonDoc } from "../../lib/types";
import { Goal } from "./Goal";
import { Kit } from "./Kit";

export function LessonBody({ doc }: { doc: LessonDoc }) {
  return (
    <div className="lesson">
      {doc.blocks.length ? (
        <div className="lesson-intro"><Blocks blocks={doc.blocks} /></div>
      ) : null}
      <Goal goal={doc.goal} />
      <Kit kit={doc.kit} lesson={doc.id} />
    </div>
  );
}
